import { defineComponent as _defineComponent } from 'vue'
import EmptyContent from "@/components/shared/EmptyContent.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";
import SegmentedControl from "@/components/shared/SegmentedControl.vue";
import { useServiceStore } from "@/stores/serviceStore";
import { computed, ref } from "vue";


const __default__ = {
  name: "BusStopLayout",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const serviceStore = useServiceStore();

const busStopLayouts = computed(
  () => serviceStore.serviceInfo?.busStopLayouts ?? []
);

const campusNames = computed(() =>
  busStopLayouts.value?.map((layout) => layout.campusName)
);

const currentSegmentIndex = ref(0);
const onChangedSegmentIndex = (index: number) => {
  currentSegmentIndex.value = index;
};

const __returned__ = { serviceStore, busStopLayouts, campusNames, currentSegmentIndex, onChangedSegmentIndex, EmptyContent, NavigationBar, Page, SegmentedControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})